import React from 'react';
import ringArt from '../../assets/img/portal-ring.png';

/**
 * The I'M DOWN beat (handoff v3 §7), inside the viewer: the Portal's own background at 35%
 * drifting under a scrim, the 160px ring popping in and spinning counter-clockwise, the
 * host's face in it, two cyan ripples, JOINING… then YOU'RE IN. The viewer owns the clock;
 * this only draws the phase it is told (`beat` in, `out` fading, `error` with RETRY).
 */
const EASE_OUT = 'cubic-bezier(0,0,.2,1)';

export default function ImDownBeat({ phase = 'beat', title = 'JOINING…', sub = null, avatarUrl = null, handle = '', inCount = 0, winShort = '', background = null, onRetry = null, onClose = null }) {
  if (phase === 'error') {
    return (
      <div role="alert" className="absolute inset-0 flex flex-col items-center justify-center font-mono text-white" style={{ zIndex: 40, background: '#000', gap: 14, padding: 32, textAlign: 'center' }} data-testid="im-down-error">
        <span style={{ fontSize: 14, fontWeight: 700, letterSpacing: '0.1em' }}>THAT DIDN’T GO THROUGH.</span>
        <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.12em', color: 'rgba(255,255,255,.65)' }}>NOTHING CHANGED. TRY IT AGAIN.</span>
        <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
          <button type="button" onClick={onRetry} className="prc-pill" style={{ height: 44, padding: '0 22px', background: '#fff', color: '#000', border: 0, borderRadius: 999, fontFamily: 'inherit', fontSize: 12, fontWeight: 700, letterSpacing: '0.14em', cursor: 'pointer' }}>RETRY</button>
          <button type="button" onClick={onClose} className="prc-pill" style={{ height: 44, padding: '0 22px', background: 'rgba(255,255,255,.14)', color: '#fff', border: 0, borderRadius: 999, fontFamily: 'inherit', fontSize: 12, fontWeight: 700, letterSpacing: '0.14em', cursor: 'pointer' }}>NOT NOW</button>
        </div>
      </div>
    );
  }
  return (
    <div
      aria-live="polite"
      role="status"
      className="prc-motion absolute inset-0 flex flex-col items-center justify-center overflow-hidden font-mono text-white"
      data-testid="im-down-beat"
      data-phase={phase}
      style={{ zIndex: 40, background: '#000', gap: 16, opacity: phase === 'out' ? 0 : 1, transition: 'opacity .3s cubic-bezier(.4,0,1,1)', animation: 'prcFadeIn .2s linear both' }}
    >
      {background && (
        <div aria-hidden style={{ position: 'absolute', inset: '-10%', opacity: 0.35, animation: 'prcDriftZ 1.8s ease-out both' }}>{background}</div>
      )}
      <div aria-hidden style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,.55)' }} />
      <span aria-hidden style={{ position: 'relative', display: 'block', width: 160, height: 160, animation: `prcPop .42s ${EASE_OUT} both` }}>
        <span style={{ position: 'absolute', inset: 0, borderRadius: '50%', border: '2px solid #00FFFF', animation: `prcRipple 1.5s ${EASE_OUT} .35s infinite both` }} />
        <span style={{ position: 'absolute', inset: 0, borderRadius: '50%', border: '2px solid #00FFFF', animation: `prcRipple 1.5s ${EASE_OUT} .85s infinite both` }} />
        <span style={{ position: 'absolute', inset: 0, borderRadius: '50%', backgroundImage: `url(${ringArt})`, backgroundSize: 'cover', animation: 'prcSpin 1.1s linear infinite reverse' }} />
        <span style={{ position: 'absolute', inset: '5.5%', borderRadius: '50%', overflow: 'hidden', background: '#1A1A1A', animation: `prcPop .42s ${EASE_OUT} .12s both` }}>
          {avatarUrl && <img src={avatarUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />}
        </span>
      </span>
      <span data-testid="beat-title" style={{ position: 'relative', fontSize: 14, fontWeight: 700, letterSpacing: '0.1em', animation: `prcRise .32s ${EASE_OUT} .3s both` }}>{title}</span>
      <span style={{ position: 'relative', fontSize: 10, fontWeight: 700, letterSpacing: '0.12em', color: 'rgba(255,255,255,.65)', animation: `prcRise .32s ${EASE_OUT} .36s both` }}>
        {sub || [handle.toUpperCase(), `${inCount} IN`, winShort].filter(Boolean).join(' · ')}
      </span>
    </div>
  );
}
